import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CupraBudgetModel } from '../models/cuprabudget';
import { DataTablesResponse } from '../models/common';

@Injectable({
  providedIn: 'root'
})

export class CupraBudgetService {

  private pathAPI = environment.urlAPI;
  private controller = "CupraBudget/";

  constructor(private http: HttpClient) { }

  public searchData(data: any): Observable<DataTablesResponse> {
    return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDataTable', data);
  }

  public changeStatus(id: string, idStatus: number): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id + '/' + idStatus, null);
  }

  public post(data: CupraBudgetModel): Observable<CupraBudgetModel> {
    return this.http.post<CupraBudgetModel>(this.pathAPI + this.controller, data);
  }
  public put(id: string, data: any): Observable<any> {
    return this.http.put<any>(this.pathAPI + this.controller + id, data);
  }

  public get(id: string): Observable<CupraBudgetModel> {
    return this.http.get<CupraBudgetModel>(this.pathAPI + this.controller + id);
  }

  public getByCode(id: string): Observable<CupraBudgetModel> {
    return this.http.get<CupraBudgetModel>(this.pathAPI + this.controller + "GetByCode/" + id);
  }

  public GetPdf(idBudget: string): Observable<any> {
    let requestOptions: Object = {
      responseType: 'blob'
    }
    let endpoint = this.pathAPI + this.controller + 'GetPdf/' + idBudget;

    return this.http.get<Blob>(endpoint, requestOptions);
  }

  public SendMail(idBudget: string, email: string): Observable<CupraBudgetModel> {
    return this.http.get<CupraBudgetModel>(this.pathAPI + this.controller + 'SendMail/' + idBudget + "/" + email);
  }

  public SendBudgetEMR(idBudget: string): Observable<any> {
    return this.http.get<any>(this.pathAPI + this.controller + "SendBudgetEMR/" + idBudget);
  }


}
